import { CountryListPosition, GetCountryListPositionParams } from './phoneField.types';

const COUNTRY_LIST_OFFSET = 4;
const VIEWPORT_MARGIN = 8;

let countryFlagStylesRequest: Promise<void> | undefined;

const toCountryFlagRule = ([countryCode, svg]: [string, string]) =>
  `.react-tel-input .flag.${countryCode.toLowerCase()}{background:url("data:image/svg+xml,${encodeURIComponent(svg)}") 0 4px / 24px 16px no-repeat}`;

export const loadCountryFlagStyles = () => {
  countryFlagStylesRequest ??= import('country-flag-icons/string/3x2')
    .then((flags) => {
      const style = document.createElement('style');
      style.textContent = Object.entries(flags).map(toCountryFlagRule).join('');
      document.head.append(style);
    })
    .catch(() => {
      countryFlagStylesRequest = undefined;
    });

  return countryFlagStylesRequest;
};

export const showInTopLayer = (element: HTMLElement) => {
  if (!('showPopover' in element) || element.matches(':popover-open')) {
    return;
  }

  element.popover = 'manual';
  element.showPopover();
};

export const getCountryListPosition = ({
  anchorRect,
  listSize,
  viewportSize,
}: GetCountryListPositionParams): CountryListPosition => {
  const spaceBelow =
    viewportSize.height - anchorRect.bottom - COUNTRY_LIST_OFFSET - VIEWPORT_MARGIN;
  const spaceAbove = anchorRect.top - COUNTRY_LIST_OFFSET - VIEWPORT_MARGIN;
  const isOpeningUpward = listSize.height > spaceBelow && spaceAbove > spaceBelow;
  const maxHeight = Math.min(listSize.height, isOpeningUpward ? spaceAbove : spaceBelow);
  const top = isOpeningUpward
    ? anchorRect.top - COUNTRY_LIST_OFFSET - maxHeight
    : anchorRect.bottom + COUNTRY_LIST_OFFSET;
  const maxLeft = viewportSize.width - listSize.width - VIEWPORT_MARGIN;

  return {
    top: Math.max(top, VIEWPORT_MARGIN),
    left: Math.max(Math.min(anchorRect.left, maxLeft), VIEWPORT_MARGIN),
    maxHeight,
  };
};
